module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav.9f290afe.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/PrevSliderButton/images/prev-nav.png
// module id = 3158
// module chunks = 11